import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import NotificationsPanelUnreadIndicator from "../NotificationsPanelUnreadIndicator/NotificationsPanelUnreadIndicator";

export default function NotificationsPanelItem({ notification, handleUpdateNotification, handleClose, ...props }) {
  const [isRead, setIsRead] = useState(false);
  const navigate = useNavigate();

  const handleMarkAsRead = () => {
    const updatedNotification = notification;
    updatedNotification.isRead = true;
    setIsRead(true);
    handleUpdateNotification(updatedNotification);
  };

  const handleClick = () => {
    if (!notification.isRead) {
      handleMarkAsRead();
    }
    navigate(`/dashboard/offer-boards?loadId=${notification.orderId}`);
    handleClose();
  };

  useEffect(() => {
    setIsRead(notification.isRead);
  }, [notification.isRead]);

  return(
    <Box>
      <Box sx={{ display: "flex", margin: "8px"}}>
        <Box sx={{ width: "296px", "&:hover": {cursor: "pointer"} }} onClick={handleClick}>
          {props.children}
        </Box>
        <Box 
          sx={{ 
            width: "24px",
            flexShrink: 0,
            alignSelf: "stretch",
            marginLeft: "auto", 
            paddingTop: "3px"
          }}
        >
          {!isRead &&
            <NotificationsPanelUnreadIndicator handleMarkAsRead={handleMarkAsRead} />
          }
        </Box>
      </Box>
      <Box 
        sx={{ 
          display: "flex",
          padding: "0px 4px",
          margin: "4px 0",
          height: "1px",
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "stretch",
          backgroundColor: "black_solid.20"
        }} 
      />
    </Box>
  );
}

NotificationsPanelItem.propTypes = {
  notification: PropTypes.object.isRequired,
  handleUpdateNotification: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node
};